// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__ABLUu","header":"ReportDetails_header__2p4A-","title":"ReportDetails_title__HPCdY","left":"ReportDetails_left__HeijJ"};